import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateFullBreakdownPdf } from "../../Others/Pdf/generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const FullBreakdownPdf = ({
  schedule,
  company,
  sourceData,
  grossBalance,
  adjustedTotalBalance,
  totalSourceAmount,
  lines,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    sourceData,
    grossBalance,
    adjustedTotalBalance,
    totalSourceAmount,
    lines,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateFullBreakdownPdf(forView, ...sharedArgs)
        }
        downloadName='Full Breakdown'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFullBreakdownPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default FullBreakdownPdf;
